import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Trophy, XCircle } from "lucide-react";

const MOTIVI = ["Non raggiungibile", "Non interessato", "Rifiutato dalla banca", "Scelto concorrente", "Documenti mancanti", "Altro"];

export default function OutcomeDialog({ stage, leadName, onConfirm, onCancel }) {
  const erogato = stage === "Erogato";
  const [importo, setImporto] = useState("");
  const [banca, setBanca] = useState("");
  const [motivo, setMotivo] = useState(MOTIVI[0]);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try { await onConfirm(erogato ? { importo, banca, note } : { motivo, note }); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onCancel()}>
      <DialogContent data-testid="outcome-dialog" className="bg-slate-950 border-white/10 text-slate-100 sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            {erogato ? <Trophy className="h-5 w-5 text-amber-400" /> : <XCircle className="h-5 w-5 text-rose-400" />}
            {erogato ? "Pratica erogata" : "Lead perso"} — {leadName}
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            {erogato ? "Registra l'esito finale: serve per le statistiche di conversione e il feedback alle campagne." : "Indica il motivo: ci aiuta a migliorare la qualificazione."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {erogato ? (
            <>
              <Input data-testid="outcome-importo" type="number" min="0" placeholder="Importo erogato (€)" value={importo} onChange={(e) => setImporto(e.target.value)} className="bg-slate-900 border-white/10" />
              <Input data-testid="outcome-banca" placeholder="Banca / istituto" value={banca} onChange={(e) => setBanca(e.target.value)} className="bg-slate-900 border-white/10" />
            </>
          ) : (
            <div className="flex flex-wrap gap-2">
              {MOTIVI.map((m) => (
                <button key={m} type="button" data-testid={`outcome-motivo-${m.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setMotivo(m)}
                  className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${motivo === m ? "bg-rose-500/20 border-rose-400 text-rose-200" : "border-white/10 text-slate-300 hover:bg-white/5"}`}>{m}</button>
              ))}
            </div>
          )}
          <Textarea data-testid="outcome-note" placeholder="Note (facoltative)" value={note} onChange={(e) => setNote(e.target.value)} className="bg-slate-900 border-white/10 min-h-[70px]" />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onCancel} data-testid="outcome-cancel">Annulla</Button>
          <Button onClick={submit} disabled={busy} data-testid="outcome-confirm" className={erogato ? "bg-amber-500 hover:bg-amber-600 text-black" : "bg-rose-600 hover:bg-rose-700 text-white"}>
            {erogato ? "Conferma erogazione" : "Conferma perdita"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
